export enum FileOwner {
    USER = 1,
}
